import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import VerticalContainer from "../../shared/VerticalContainer/VerticalContainer"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useVentaEnLineaCountdown } from "../../../../hooks/useVentaEnLineaCountdown"

import "./VentaEnLinea.css"

const VentaEnLinea = (props: RoomStatusProps) => {
    const { timeLeft, isExceeded } = useVentaEnLineaCountdown(
        props.occupiedTimeStart,
        props.occupiedTimeEndCondensada
    )

    return (
        <Wrapper>
            <RoomCardHeader
                hasIncidences={props.hasIncidences}
                iconName={"DoorOpenNew"}
                roomNumber={props.roomNumber}
                roomTypeName={props.roomTypeName}
                iconBgColor="var(--purple-drawer-primario)"
            />
            <VerticalContainer>
                {isExceeded ? (
                    <>
                        <div className="room-card--md--venta-en-linea__label">Venta en línea</div>
                        <div className="room-card--md--venta-en-linea__no-show">No show</div>
                    </>
                ) : (
                    <>
                        <div className="room-card--md--venta-en-linea__timer">{timeLeft}</div>
                        <div className="room-card--md--venta-en-linea__codigo">
                            Código: {props.ventaEnLineaCodigo || "-"}
                        </div>
                    </>
                )}
            </VerticalContainer>
        </Wrapper>
    )
}

export default VentaEnLinea
